export enum MissionStatus {
    newMission = 1,
    inProgress = 2,
    onPause = 4,
    completed = 8,
    cancelled = 16,
    // tslint:disable-next-line: no-bitwise
    all = newMission | inProgress | onPause | completed | cancelled
}
